var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerReporte"),
      _vm._v(" "),
      _c("AbrirCerrarTipificacionDia"),
      _vm._v(" "),
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
        }
      }),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: {
                dark: "",
                color: "light-blue darken-3",
                to: "/asistencia-tipificacion",
                title: "Volver"
              }
            },
            [_c("v-icon", [_vm._v("arrow_back")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v(" build ")]),
              _vm._v(
                "\n      Ajuste procesamiento de control de asistencia\n    "
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [_c("DatosPersonales", { attrs: { id_persona: this.id_persona } })],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "text-field-reducido-border",
                        attrs: {
                          type: "date",
                          label: "Fecha marcado",
                          rules: _vm.$validate(["required"]),
                          required: "",
                          outline: "",
                          clearable: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.actualizarDatos()
                          }
                        },
                        model: {
                          value: _vm.form.fecha,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fecha", $$v)
                          },
                          expression: "form.fecha"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-layout",
                {
                  attrs: {
                    row: "",
                    wrap: "",
                    "align-center": "",
                    "justify-space-between": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs6: "" } },
                    [
                      _c(
                        "v-tooltip",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                dark: "",
                                color: "light-blue darken-3"
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.actualizarDatos()
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("refresh")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Recargar listado")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "text-xs-right", attrs: { xs6: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            dark: "",
                            color: "light-blue darken-3",
                            title: "Ver reporte de asistencia del funcionario"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.verReporte()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("picture_as_pdf")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { shrink: "" } }, [
                    _c("b", { staticClass: "blue--text" }, [_vm._v("DIA: ")]),
                    _vm._v(_vm._s(_vm.asistencia.dia))
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            slot: "activator",
                            dark: "",
                            color: "indigo",
                            large: "",
                            outline: "",
                            title: _vm.cierre_control.cerrado
                              ? "Abrir día"
                              : "Cerrar día",
                            disabled: _vm.asistencia.marcados.length == 0
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.abrirCerrarDia()
                            }
                          },
                          slot: "activator"
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.cierre_control.cerrado
                                  ? "lock"
                                  : "lock_open "
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { shrink: "" } }, [
                    _c("b", { staticClass: "blue--text" }, [
                      _vm._v("TOTAL MINUTOS ATRASO DIA: ")
                    ]),
                    _vm._v(
                      _vm._s(
                        parseInt(
                          _vm.asistencia.marcados.reduce(function(
                            acumulador,
                            marcado
                          ) {
                            return acumulador + marcado.atraso
                          },
                          0)
                        )
                      )
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.loading === true
                ? _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "text-xs-center", attrs: { xs12: "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              slot: "activator",
                              indeterminate: "",
                              color: "light-blue darken-3",
                              size: "90",
                              width: "7"
                            },
                            slot: "activator"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "v-layout",
                    { attrs: { row: "" } },
                    [
                      _c("v-flex", { attrs: { grow: "" } }, [
                        _c(
                          "table",
                          { staticClass: "table-marcado" },
                          [
                            _c("tr", [
                              _c("th", [_vm._v("Horario")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Tolerancia")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Marcado")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Atraso")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Descripción")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Clasificación")])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.asistencia.marcados, function(marcado) {
                              return _c(
                                "tr",
                                {
                                  key: marcado.id_control_asistencia,
                                  style:
                                    marcado.atraso > 0
                                      ? "background:rgb(219, 62, 177,0.3"
                                      : marcado.tipo_marcado == "I"
                                      ? "background:rgb(252, 76, 2,0.3"
                                      : ""
                                },
                                [
                                  _c("td", { staticStyle: { width: "10%" } }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(marcado.horario) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticStyle: { width: "10%" } }, [
                                    _vm._v(_vm._s(marcado.tolerancia))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticStyle: { width: "10%" } }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          marcado.hora_marcada
                                            ? marcado.hora_marcada
                                            : "-"
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticStyle: { width: "10%" } },
                                    [
                                      marcado.tipo_marcado == "A" &&
                                      !_vm.cierre_control.cerrado
                                        ? _c("v-text-field", {
                                            staticClass:
                                              "text-field-reducido text-xs-center",
                                            staticStyle: {
                                              "text-align": "center"
                                            },
                                            attrs: {
                                              type: "number",
                                              "hide-details": "",
                                              "single-line": ""
                                            },
                                            model: {
                                              value: marcado.atraso,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  marcado,
                                                  "atraso",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "marcado.atraso"
                                            }
                                          })
                                        : _c("span", [
                                            _vm._v(_vm._s(marcado.atraso))
                                          ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        width: "45%",
                                        "font-size": "0.9em"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            color: "indigo lighten-1"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(marcado.descripcion_caso)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "1.3em"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    marcado.descripcion_caso
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticStyle: { width: "25%" } },
                                    [
                                      _c("v-autocomplete", {
                                        staticClass: "text-field-reducido",
                                        attrs: {
                                          disabled: _vm.cierre_control.cerrado,
                                          solo: "",
                                          items: _vm.l_tipos_marcado,
                                          "item-text": "descripcion",
                                          "item-value": "valor",
                                          label: "Tipo de marcado",
                                          required: "",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: marcado.tipo_marcado,
                                          callback: function($$v) {
                                            _vm.$set(
                                              marcado,
                                              "tipo_marcado",
                                              $$v
                                            )
                                          },
                                          expression: "marcado.tipo_marcado"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.asistencia.marcados.length == 0
                              ? _c("tr", [
                                  _c("td", { attrs: { colspan: "6" } }, [
                                    _c("b", [_vm._v("NO CUENTA CON MARCADOS")])
                                  ])
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm.asistencia.marcados.length > 0 &&
                      !_vm.cierre_control.cerrado
                        ? _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "rgba(0, 175, 215,0.1)"
                              },
                              attrs: { xs2: "" }
                            },
                            [
                              _c(
                                "table",
                                { staticClass: "table-marcado-drag" },
                                [
                                  _c("tr", [_c("th", [_vm._v("MARCADO")])]),
                                  _vm._v(" "),
                                  _c(
                                    "tr",
                                    [
                                      _c(
                                        "VueDraggable",
                                        {
                                          staticClass: "list-wrapper__dragarea",
                                          attrs: {
                                            list: _vm.asistencia.marcados_drag,
                                            options: {
                                              group: "a",
                                              animation: 150
                                            },
                                            "no-transition-on-drag": true
                                          },
                                          on: {
                                            start: function($event) {
                                              _vm.drag = true
                                            },
                                            end: function($event) {
                                              _vm.drag = false
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "transition-group",
                                            {
                                              attrs: {
                                                name: !_vm.drag
                                                  ? "list-complete"
                                                  : null,
                                                css: true
                                              }
                                            },
                                            _vm._l(
                                              _vm.asistencia.marcados_drag,
                                              function(marcado) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      marcado.id_control_asistencia,
                                                    staticClass:
                                                      "div-list align-center d-flex"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          marcado.hora_marcada
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "#0076A8",
                    title: "Guardar ajustes",
                    dark: "",
                    block: "",
                    disabled:
                      _vm.cierre_control.cerrado ||
                      this.asistencia.marcados.length == 0
                  },
                  on: {
                    click: function($event) {
                      return _vm.guardarAjuste()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("save")]),
                  _vm._v("GUARDAR AJUSTE\n      ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-expansion-panel",
            { attrs: { popout: "" } },
            [
              _c(
                "v-expansion-panel-content",
                {
                  staticStyle: { background: "#006298" },
                  scopedSlots: _vm._u([
                    {
                      key: "actions",
                      fn: function() {
                        return [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("$vuetify.icons.expand")
                          ])
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "text-xs-center white--text" },
                            [_vm._v("SEGUIMIENTO")]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c("SeguimientoTipificacion", {
                        key: _vm.key_actualizacion,
                        attrs: {
                          fecha_marcado: _vm.form.fecha,
                          id_persona: _vm.id_persona
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-expansion-panel",
            { attrs: { popout: "" } },
            [
              _c(
                "v-expansion-panel-content",
                {
                  staticStyle: { background: "#00838F" },
                  scopedSlots: _vm._u([
                    {
                      key: "actions",
                      fn: function() {
                        return [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("$vuetify.icons.expand")
                          ])
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "text-xs-center white--text" },
                            [_vm._v("HISTORICO AJUSTES")]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c("HistoricoAjustes", {
                        key: _vm.key_actualizacion,
                        attrs: {
                          fecha_marcado: _vm.form.fecha,
                          id_persona: _vm.id_persona
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d945547", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d945547","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/tipificacion/AjusteTipificacion.vue
// module id = null
// module chunks = 